import { useTranslation } from 'react-i18next';
import { Descriptions, Modal, Tag, Button, Space, message } from 'antd';
import { ArrowDownOutlined, DeleteOutlined } from '@ant-design/icons';
import { CustomConfirmPopup } from '../../components/CustomConfirmPopup/CustomConfirmPopup';
import PermissionChecker from '../../PermissionChecker';
import http from '../../http';
import { getReadableDateFromTimeStamp } from '../../utils/common';

const MachineRegistryDetailsModal = ({ record, onClose, sideEffect }) => {
    const { t } = useTranslation();

    const handleRegistryFileDownload = (record) => {
        http.get(`/api/v1/machines/machine_registry_files/${record.id}/download/`)
            .then((resp) => {
                if (resp.status === 200) {
                    const blob = new Blob([JSON.stringify(resp.data, null, 2)], {
                        type: 'application/json',
                    });
                    const link = document.createElement('a');
                    link.download = `${record.name}`;
                    link.href = window.URL.createObjectURL(blob);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
            .catch((err) => {});
    };

    const handleRegistryFileDelete = (record) => {
        http.delete(`/api/v1/machines/machine_registry_files/${record.id}/delete/`)
            .then((resp) => {
                if (resp.status === 204) {
                    message.success(t('registry_file_delete_successful_message'));
                    sideEffect && sideEffect();
                    onClose();
                } else {
                    message.error(t(resp?.data?.error));
                }
            })
            .catch((error) => {
                message.error(t(error.response?.data?.error));
            });
    };

    return (
        <Modal
            open={Boolean(record)}
            title={t('registry_calibration_profile')}
            onCancel={onClose}
            footer={null}
            width={600}
            centered
        >
            <Descriptions column={1} bordered labelStyle={{ width: '200px' }}>
                <Descriptions.Item label={t('profile_filelist_col1')}>
                    {getReadableDateFromTimeStamp(record?.created)}
                </Descriptions.Item>
                <Descriptions.Item label={t('registry_profile_name')}>
                    {record?.name}
                </Descriptions.Item>
                <Descriptions.Item label={t('registry_status')}>
                    <Tag color={record?.status_text === 'active_label' ? 'green' : 'red'}>
                        {t(record?.status_text)}
                    </Tag>
                </Descriptions.Item>
                <Descriptions.Item label={t('registry_calibration_operator')}>
                    {record?.data?.metadata?.operator_info?.name || '-'}
                </Descriptions.Item>
            </Descriptions>

            <div style={{ marginTop: 16, textAlign: 'right' }}>
                <Space>
                    <CustomConfirmPopup
                        title={t('registry_file_download_confirmation_text')}
                        onConfirm={() => handleRegistryFileDownload(record)}
                        icon={<ArrowDownOutlined />}
                        okText={t('yes_text')}
                        cancelText={t('no_text')}
                        disabled={false}
                        okType='default'
                    >
                        <PermissionChecker requiredPermissions={['machine-registry-file-download']}>
                            <Button
                                icon={<ArrowDownOutlined />}
                                className={'bordered-default-button'}
                            >
                                {t('download_button_text')}
                            </Button>
                        </PermissionChecker>
                    </CustomConfirmPopup>

                    <CustomConfirmPopup
                        title={t('registry_file_delete_confirmation_text')}
                        onConfirm={() => handleRegistryFileDelete(record)}
                        okText={t('yes_text')}
                        cancelText={t('no_text')}
                        disabled={false}
                        okType='default'
                    >
                        <PermissionChecker requiredPermissions={['machine-registry-file-delete']}>
                            <Button
                                className={'button-cancel'}
                                disabled={record?.active}
                                icon={<DeleteOutlined />}
                            >
                                {t('machine_registry_file_delete_button_text')}
                            </Button>
                        </PermissionChecker>
                    </CustomConfirmPopup>
                </Space>
            </div>
        </Modal>
    );
};

export default MachineRegistryDetailsModal;
